var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpdate = function SvgUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6927 5.73294H14.0207L11.9 3.61094C11.2173 2.92818 10.3668 2.4372 9.43414 2.18734C8.50148 1.93748 7.51947 1.93755 6.58685 2.18755C5.65422 2.43755 4.80384 2.92866 4.1212 3.61152C3.43856 4.29437 2.94771 5.1449 2.698 6.0776M2.00067 12.5969V9.26894M2.00067 9.26894H5.32867M2.00067 9.26894L4.12067 11.3909C4.80341 12.0737 5.65386 12.5647 6.58653 12.8145C7.51919 13.0644 8.50119 13.0643 9.43382 12.8143C10.3664 12.5643 11.2168 12.0732 11.8995 11.3904C12.5821 10.7075 13.073 9.85697 13.3227 8.92427M14.0207 2.40494V5.7316",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUpdate;